import FormAngebotDto from "../../../../consumer/form/dto/FormAngebotDto";
import StvSelbstbeteiligung from "../../../../consumer/form/dto/StvSelbstbeteiligung";
import StvVersicherungssumme from "../../../../consumer/form/dto/StvVersicherungssumme";
import StvZahlungsweise from "../../../../consumer/form/dto/StvZahlungsweise";
import { exportSelbstbehalt } from "./input/Selbstbehalt";
import { exportVs } from "./input/Vs";
import { exportZahlungsweise } from "./input/Zahlungsweise";
import { exportProduktMitSchutzbrief } from "./produkt/Produkt";

export default class FormBo {
    zahlungsweise = StvZahlungsweise.MONATLICH;

    selbstbehalt = StvSelbstbeteiligung.OHNE;

    vs = StvVersicherungssumme.VS_20MIO;

    produktMitSchutzbrief = true;

    static exportFormulardaten(bo: FormBo) {
        const dto = new FormAngebotDto();
        dto.zahlungsweise = exportZahlungsweise(bo);
        dto.selbstbehalt = exportSelbstbehalt(bo);
        dto.vs = exportVs(bo);
        dto.produktMitSchutzbrief = exportProduktMitSchutzbrief(bo);
        return dto;
    }


}